import { render, staticRenderFns } from "./preview-template.vue?vue&type=template&id=0b158d7e&"
import script from "./preview-template.vue?vue&type=script&lang=js&"
export * from "./preview-template.vue?vue&type=script&lang=js&"
import style0 from "./preview-template.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports